// Leaving for future use so that we could know where to only changes are needed. Before we had "/next" for production
export const assetPrefix = '';
